export default "__VITE_ASSET__CXWzDSPx__"